module.exports = __webpack_public_path__ + "img/back6.f3dbe670.jpg";